module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "bonzi_3.6b93f1ff.mp3" + "?" + Date.now();